export default __webpack_public_path__ + "static/toolBox-8679220a8252131c628b15638803aafe.svg";